define('editor/edit/map/controls/state-change-reporter',['durandal/app', 'plugins/http'], function (app, http) {
    var control = function() {
        var self = this;

        self.saveState = function (mapId, layerId, newState) {
            var url = '/api/editor/layers/state';
            var data = {
                editorMapId: mapId,
                layerId: layerId,
                newState: newState
            };
            
            return http.post(url, data)
                .fail(app.showError);
        };
    };

    return control;
});

